import React from 'react';
import styles from './index.module.less';
import cn from 'classnames';
import { getPlaceholderPercentage } from 'base/utils/dom-size';

type ILargeScreenContainerProps = Globals.BasicHTMLProps & {
    height: number;
}

export const LargeScreenContainer: React.FC<ILargeScreenContainerProps> = props => {
    const {
        className,
        style,
        height = 700,
        children,
        ...rest
    } = props;

    return process.env.NEXT_PUBLIC_TERMINAL === 'm' ? (
        <div
            className={cn(className, styles.container)}
            style={{
                ...style,
                paddingBottom: getPlaceholderPercentage(750, height)
            }}

            {...rest}
        >
            <div className={styles.wrapper}>
                {children}
            </div>
        </div>
    ) : (
        <div
            className={cn(className, styles.container)}
            style={{
                ...style,
                height: `${height}px`,
                paddingBottom: getPlaceholderPercentage(1920, height)
            }}
            {...rest}
        >
            <div className={styles.wrapper}>
                {children}
            </div>
        </div>
    );
}
